package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.rippleClick
import com.example.mystybag.common.model.IconData
import com.example.mystybag.common.model.ImageData
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.views.AppTheme

@Composable
fun OneLineTextIconClickableView(
    modifier    : Modifier      = Modifier,
    text        : String,
    textColor   : Color?        = null,
    iconModel   : IconData?     = null,
    imageModel  : ImageData?    = null,
    padding     : Dp            = p12,
    background  : Color?        = null,
    doOnClick   : () -> Unit
) {
    Row(
        modifier            = modifier
            .fillMaxWidth()
            .rippleClick(padding, action = doOnClick, background = background),
        verticalAlignment   = Alignment.CenterVertically
    ) {
        imageModel?.let { image ->
            Image(
                painter         = image.image,
                modifier        = Modifier.padding(end = p12).size(image.imageSize),
                colorFilter     = image.imageColor?.let { color -> ColorFilter.tint(color) },
                contentScale    = ContentScale.Fit
            )
        }
        iconModel?.let { icon ->
            CircleIconView(
                modifier    = Modifier.padding(end = p16),
                model       = icon
            )
        }

        Texts.TitleSmall(
            text        = text,
            color       = textColor,
            modifier    = Modifier
                .padding(end = p16)
                .weight(1f))

        Image(
            painter         = painterResource(SRC.images.ic_chevron_right),
            colorFilter     = ColorFilter.tint(AppTheme.current.colors.onSurface)
        )
    }
}